module.exports = "query getPartner($id:String!){partner(id:$id){id name locked active insurer agbsPreAccepted phone partnerValidation{intro enabled regex}}}"